import { createRepositoryToken } from '../../data/RepositoryProvider';
import type {
  DashboardFilters,
  DashboardRanking,
  DashboardSummary,
  DashboardTrends,
} from './types';

export interface DashboardRepository {
  getSummary(filters: DashboardFilters, signal: AbortSignal): Promise<DashboardSummary>;
  getTrends(filters: DashboardFilters, signal: AbortSignal): Promise<DashboardTrends>;
  getTopGames(filters: DashboardFilters, signal: AbortSignal): Promise<DashboardRanking>;
  getTopAffiliates(filters: DashboardFilters, signal: AbortSignal): Promise<DashboardRanking>;
}

export const dashboardRepositoryToken = createRepositoryToken<DashboardRepository>('dashboard');

export const defaultDashboardFilters: DashboardFilters = createDefaultDashboardFilters();

export function createDefaultDashboardFilters(now: Date = new Date()): DashboardFilters {
  const bangkokDate = dateInBangkok(now);
  return Object.freeze({
    from: `${shiftDate(bangkokDate, -30)}T00:00:00+07:00`,
    to: `${shiftDate(bangkokDate, 1)}T00:00:00+07:00`,
    timezone: 'Asia/Bangkok',
    timeBasis: 'PLAY_AT',
    partnerId: '',
    agentId: '',
    gameTypeId: '',
    gameId: '',
    currency: '',
    status: '',
  });
}

function dateInBangkok(now: Date): string {
  const parts = new Intl.DateTimeFormat('en-GB-u-ca-gregory-nu-latn', {
    day: '2-digit',
    month: '2-digit',
    timeZone: 'Asia/Bangkok',
    year: 'numeric',
  }).formatToParts(now);
  const part = (type: Intl.DateTimeFormatPartTypes) => {
    const value = parts.find((candidate) => candidate.type === type)?.value;
    if (value === undefined) throw new RangeError(`Dashboard date formatter omitted ${type}`);
    return value;
  };
  return `${part('year')}-${part('month')}-${part('day')}`;
}

function shiftDate(date: string, days: number): string {
  const [year, month, day] = date.split('-').map(Number);
  if (year === undefined || month === undefined || day === undefined) {
    throw new RangeError('Dashboard date range is invalid');
  }
  const shifted = new Date(Date.UTC(year, month - 1, day + days));
  return shifted.toISOString().slice(0, 10);
}
